import React from "react";
import parse from "html-react-parser";

import FaqGroup from "./FaqGroup";
import { DefaultProps } from "model/props";
import { FaqItem } from "model/faq";
import FaqItems from "faqItems.mjs";
import { Link } from "@mui/material";
import css from "../content.module.scss";
import { Pages } from "appConfig";
import { FaqTagMap } from "misc/faq_util";

export interface Props extends DefaultProps {
  faqItem?: FaqItem;
  faqTagMap?: FaqTagMap;
}

const SupportPage: React.FC<Props> = (props) => {
  const { navigate, faqItem, faqTagMap } = props;

  const images = require.context("../../../assets/images/faq", true);

  const onClick = (event: any, item: FaqItem) => {
    window.scrollTo(0, 0);
    return navigate("/" + item.id, event, item.title);
  };

  const related: FaqItem[] = [];
  if (faqItem && faqTagMap) {
    document.title = "Onelink.to - " + faqItem.title;
    const set: { [id: string]: FaqItem } = {};

    for (const tag of faqItem.tags || []) {
      const items = faqTagMap[tag];
      for (const item of items || []) {
        if (item.id === faqItem.id) continue;
        if (set[item.id]) continue;
        set[item.id] = item;
        if (items) related.push(item);
      }
    }
  }

  return (
    <div className={css.page}>
      {/*/////////////////////////////////////////////*/}
      {faqItem && (
        <div className={css.item}>
          <h1 className={css.heading}>{faqItem.title}</h1>
          <div className={css.content}>
            {faqItem.content.map((text, index) => {
              const isImage = text.endsWith(".png") || text.endsWith(".svg");
              if (isImage) {
                return (
                  <img key={"img" + index} src={images(`./${text}`)} alt="" />
                );
              } else {
                return <div key={"text" + index}>{parse(text)}</div>;
              }
            })}
          </div>

          {(related?.length > 0) && (
            <FaqGroup
              title={"Related Questions"}
              items={related}
              expandAll={true}
              onClick={onClick}
              hideToggle={true}
            />
          )}

          <Link
            className={css.backLink}
            href={Pages.SUPPORT.path}
            onClick={(event) => navigate(Pages.SUPPORT, event)}
          >
            Back to Support
          </Link>
        </div>
      )}
      {/*/////////////////////////////////////////////*/}
      {!faqItem && (
        <>
          <h1 className={css.heading}>Support and FAQ</h1>
          {/* <div className={css.expandAll}>
            <Button onClick={() => setExpandAll(!expandAll)}>
              {expandAll ? "Hide all" : "Expand all"}
            </Button>
          </div> */}

          {FaqItems.map((group, index) => (
            <FaqGroup
              key={"g" + index}
              title={group.title}
              items={group.items}
              expandAll={false}
              defaultExpanded={true}
              onClick={onClick}
            />
          ))}
        </>
      )}
    </div>
  );
};

export default SupportPage;
